/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationSkuItem } from './AdminStockAdjustLocationSkuItem';
import {
    AdminStockAdjustLocationSkuItemFromJSON,
    AdminStockAdjustLocationSkuItemFromJSONTyped,
    AdminStockAdjustLocationSkuItemToJSON,
    AdminStockAdjustLocationSkuItemToJSONTyped,
} from './AdminStockAdjustLocationSkuItem';

/**
 * 
 * @export
 * @interface AdminStockAdjustLocationAddBoxResVo
 */
export interface AdminStockAdjustLocationAddBoxResVo {
    /**
     * 箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    boxId?: number;
    /**
     * 箱唛编号
     * @type {string}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    markNo?: string;
    /**
     * 长度(厘米)
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    length?: number;
    /**
     * 宽度(厘米)
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    width?: number;
    /**
     * 高度(厘米)
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    height?: number;
    /**
     * 尺寸展示，如 50 x 50 x 40
     * @type {string}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    dimensionSpec?: string;
    /**
     * 计费CBM
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    cbm?: number;
    /**
     * SKU 数
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    skuCount?: number;
    /**
     * 库存件数
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    inventoryQty?: number;
    /**
     * 货位号
     * @type {string}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    locationNo?: string;
    /**
     * 是否单独保管：0 否 1 是
     * @type {number}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    separateStore?: number;
    /**
     * 箱内 SKU 明细
     * @type {Array<AdminStockAdjustLocationSkuItem>}
     * @memberof AdminStockAdjustLocationAddBoxResVo
     */
    skus?: Array<AdminStockAdjustLocationSkuItem>;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationAddBoxResVo interface.
 */
export function instanceOfAdminStockAdjustLocationAddBoxResVo(value: object): value is AdminStockAdjustLocationAddBoxResVo {
    return true;
}

export function AdminStockAdjustLocationAddBoxResVoFromJSON(json: any): AdminStockAdjustLocationAddBoxResVo {
    return AdminStockAdjustLocationAddBoxResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationAddBoxResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationAddBoxResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'dimensionSpec': json['dimensionSpec'] == null ? undefined : json['dimensionSpec'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'inventoryQty': json['inventoryQty'] == null ? undefined : json['inventoryQty'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(AdminStockAdjustLocationSkuItemFromJSON)),
    };
}

export function AdminStockAdjustLocationAddBoxResVoToJSON(json: any): AdminStockAdjustLocationAddBoxResVo {
    return AdminStockAdjustLocationAddBoxResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationAddBoxResVoToJSONTyped(value?: AdminStockAdjustLocationAddBoxResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'markNo': value['markNo'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'dimensionSpec': value['dimensionSpec'],
        'cbm': value['cbm'],
        'skuCount': value['skuCount'],
        'inventoryQty': value['inventoryQty'],
        'locationNo': value['locationNo'],
        'separateStore': value['separateStore'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(AdminStockAdjustLocationSkuItemToJSON)),
    };
}

